import React from 'react';
import { CTAButton } from './Shared';
export const HeroSection = () => {
  return <header className="relative overflow-hidden" data-id="element-121">
      <div className="bg-grid absolute inset-0 pointer-events-none" data-id="element-122" />
      <div className="absolute inset-0 bg-gradient-to-b from-familia-bg to-familia-section opacity-50 pointer-events-none" data-id="element-123" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 pt-6 pb-10 text-center" data-id="element-124">
        <p className="text-familia-gold font-bold text-[10px] sm:text-xs uppercase tracking-[0.2em] mb-3" data-id="element-125">
          ⚽ PROYECTO EDUCATIVO MUNDIALISTA 2026
        </p>

        <h2 className="text-familia-electric font-display font-bold text-xl sm:text-2xl mb-1" data-id="element-126">
          MUNDIAL EN EL AULA 360™
        </h2>

        <h1 className="font-display sm:text-4xl md:text-5xl font-extrabold mb-6 text-white text-[20px]" data-id="element-127">
          Convertí la pasión por el Mundial en aprendizaje real, con tu
          planificación de 1.º a 7.º grado lista desde hoy
        </h1>

        {/* Mockup directly below the title */}
        <div className="relative max-w-[250px] sm:max-w-[330px] md:max-w-[410px] mx-auto mb-6" style={{
        aspectRatio: '1 / 1'
      }} data-id="element-128">
          <div aria-hidden="true" className="absolute inset-0 bg-familia-electric/20 rounded-full hidden md:block" style={{
          filter: 'blur(70px)'
        }} data-id="element-129" />
          <img src="https://cdn.magicpatterns.com/uploads/vjkooUG9bQPuaLWcwwr1Zp/mega_pack_mundialista_web.webp" alt="Mega Pack Mundialista Nivel Primaria — caja digital con áreas: Geografía, Lectura, Ciencias, Matemáticas, Historia, Inglés, Arte, Educación Física, Música y más" loading="eager" className="relative z-10 w-full h-full object-contain" style={{
          filter: 'drop-shadow(0 12px 28px rgba(0,0,0,0.5))',
          mixBlendMode: 'screen'
        }} data-id="element-130" />
        </div>

        <p className="text-familia-gray sm:text-sm max-w-2xl mx-auto mb-6 font-medium text-[10px]" data-id="element-131">
          Una secuencia didáctica integral con actividades de Lengua,
          Matemática, Geografía, Ciencias, Educación Física, estadística y
          probabilidad.
          <br data-id="element-132" />
          <span className="text-familia-cyan font-bold" data-id="element-133">
            Descargás, imprimís y aplicás.
          </span>
        </p>

        <div className="flex flex-wrap gap-2 mb-6 items-start justify-center" data-id="element-134">
          {['📄 Material digital en PDF', '⚡ Acceso inmediato', '🎒 De 1.º a 7.º grado', '🖨️ Listo para imprimir'].map((badge, i) => <span key={i} className="bg-familia-card border border-familia-electric/30 px-3 py-1.5 rounded-full text-[10px] sm:text-xs font-bold flex items-center gap-1.5 text-white" data-id="element-135">
              {badge}
            </span>)}
        </div>

        <CTAButton href="#precio" className="w-full sm:w-auto text-base px-10 py-4 mb-4" data-id="element-136">
          QUIERO MI PLANIFICACIÓN MUNDIALISTA
        </CTAButton>

        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-[10px] sm:text-xs text-familia-gray font-medium pt-[12px] pb-[12px]" data-id="element-137">
          <span className="flex items-center gap-1.5" data-id="element-138">
            🛡️ Garantía de 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-139">🔒 Pago seguro</span>
          <span className="flex items-center gap-1.5" data-id="element-140">
            ♾️ Acceso de por vida
          </span>
        </div>
      </div>
    </header>;
};